class AccountSettings.PaginatedView extends Backbone.View

  template: JST['backbone/templates/account_settings/topics/paginated']
  events:
    'click .next_page': 'onClickNextPage'
    'click .previous_page': 'onClickPreviousPage'

  refreshInterval: 30000 #30 seconds

  initialize:({sourceId, model})->
    @sourceId = sourceId
    @currentPage = 1
    @nextPageNumber = 2
    @previousPageNumber = 0
    @collection = model
    @hashtagTableView = new AccountSettings.InstagramHashtagListeningTableView()

  render:=>
    @$el.html(@template(current_page: @currentPage))
    @concurrentRender()
    @hideContentsCanBeForwardedToCustomerButton()
    @

  setSearchingText:(searchingText)->
    @collectionUrlProvider = new AccountSettings.HashtagBySourceAndTextCollectionUrlProvider(@sourceId, searchingText)
    @collection.changeUrlProvider(@collectionUrlProvider)

  resetSearchingText:->
    @collectionUrlProvider = new AccountSettings.HashtagBySourceCollectionUrlProvider(@sourceId)
    @collection.changeUrlProvider(@collectionUrlProvider)

  hideContentsCanBeForwardedToCustomerButton:->
    $("label[for='keepcon_topic_customer_forwarding_enabled']").addClass('hidden')
    $('#keepcon_topic_customer_forwarding_enabled').addClass('hidden')

  concurrentRender:=>
    @disableLastTimeOut(@lastTimeOut)
    @collection.getPage(@currentPage)
    @listenTo(@collection, 'hashtag:collection:fetch:success', @renderPage)
    @lastTimeOut = setInterval(@concurrentRender,@refreshInterval)

  renderPage:(listeningHashtags, activeHashtags, totalPages)=>
    @totalPages = totalPages
    @activeHashtags = activeHashtags
    @trigger('hashtag:count:changed', @activeHashtags)
    hashtagTableRendered = @hashtagTableView.render(listeningHashtags)
    @$('.pagination-body').append(hashtagTableRendered.el)
    @enableOrDisablePreviousAndNextPageButtons()

  onClickNextPage:(event)->
    event.preventDefault()
    @incrementPagesCount()
    @concurrentRender()

  onClickPreviousPage:(event)->
    event.preventDefault()
    @decrementPagesCount()
    @concurrentRender()

  enableOrDisablePreviousAndNextPageButtons:->
    if @currentPage == 1
      @disablePreviousPageButton()
    else
      @enablePreviousPageButton()
    if @currentPage == @totalPages
      @disableNextPageButton()
    else
      @enableNextPageButton()
    @$('.current-page-number').html(@currentPage)
    @

  enableNextPageButton:->
    @$('.next_page').removeClass('disabled')
    @$('.next_page').addClass('enabled')

  disableNextPageButton:->
    @$('.next_page').removeClass('enabled')
    @$('.next_page').addClass('disabled')

  enablePreviousPageButton:->
    @$('.previous_page').removeClass('disabled')
    @$('.previous_page').addClass('enabled')

  disablePreviousPageButton:->
    @$('.previous_page').removeClass('enabled')
    @$('.previous_page').addClass('disabled')

  disableLastTimeOut:(lastTimeOutInterval)=>
    if lastTimeOutInterval
      clearInterval(lastTimeOutInterval)

  resetPagesNumber:->
    @currentPage = 1
    @nextPageNumber = 2
    @previousPageNumber = 0

  incrementPagesCount:->
    @currentPage = @currentPage + 1
    @nextPageNumber = @nextPageNumber + 1
    @previousPageNumber = @previousPageNumber + 1

  decrementPagesCount:=>
    @currentPage = @currentPage - 1
    @nextPageNumber = @nextPageNumber - 1
    @previousPageNumber = @previousPageNumber - 1
